// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2Yikq","label":"Category_label__3WIlO","content":"Category_content__3ipla","header":"Category_header__2BR4S","location":"Category_location__1ruzS"};